import { maybeUpdateTimezones, pushAnalyticsData } from "../../utils";

( function( $ ) {
	'use strict';

	$( document ).ready( function() {

		const $body = $('body').first();

		$body.on( 'mouseenter', '.grid-container .card', function(e) {
			const $card = $(this);
			const productCode = $card.data('product-code');

			window.colibri.qv_cache = window.colibri.qv_cache || { 'ready': {}, 'loading': {}, 'failed': {}, 'last_clicked': null };

			if (
				window.colibri.qv_cache['ready'][productCode] ||
				window.colibri.qv_cache['loading'][productCode] ||
				window.colibri.qv_cache['failed'][productCode]
			){
				return true;
			}

			window.colibri.qv_cache[ 'loading' ][productCode] = true;

			jQuery.ajax( {
				url: $card.data( 'ajax-source' ),
				dataType: 'text',
				type: 'GET',
			} ).done( r => {
				delete ( window.colibri.qv_cache[ 'loading' ][ productCode ] );
				window.colibri.qv_cache[ 'ready' ][ productCode ] = { qv: r, '$card': $card };
				$body.trigger( 'ColibriEvent:QUICK_VIEW_READY', { productCode } );
			} ).fail( r => {
				delete ( window.colibri.qv_cache[ 'loading' ][ productCode ] );
				window.colibri.qv_cache[ 'failed' ][ productCode ] = { qv: r, '$card': $card };
				$body.trigger( 'ColibriEvent:QUICK_VIEW_FAILED', { productCode } );
			} );

		});

		$body.on( '.card .btn.view-details', 'click', function(e) {
			const $this = $( this );
			$this.html( $this.hasClass( 'collapsed' )
				? $this.html().replace(/More/g, 'Less' )
				: $this.html().replace(/Less/g, 'More' )
			);
		});

		$('.card > product-action-button').each( (idx, ctrl) => {

			const $card = $(ctrl).closest('.card');

			if ( $card.is('[data-product-code]')) {
				const productCode = $card.data('product-code');
				$body.on( 'announceProductStatus', event => {
					// console.log('in announceProductStatus', event.detail, productCode, event.detail.products[productCode]);
					/**
					 * maybe set price to $0.00 when product is inMembership
					 */
					if ( 'products' in event.detail && event.detail.products && Object.entries(event.detail.products).length ) {
						if (productCode in event.detail.products && event.detail.products[productCode].InMembership ){
							if ( $card.find('.discounted-price').length ) {
								$card.find('.regular-price').hide();
								$card.find('.discounted-price').text( '$0.00' );
								//console.log( 'updated discounted price', productCode, $card );
							} else {
								$card.find('.regular-price').show().text('$0.00');
								//console.log( 'updated regular price', productCode, $card );
							}

						} else {
							//console.log( 'no status for product ', productCode, $card );
						}
					} else {
						//console.log('no products', productCode, $card);
					}
				} );

				// $body.on( 'announceEquivalentProductChange', event => {
				// 	const { oldValue, newValue } = event.detail;
				// 	console.log( 'announceEquivalentProductChange', event.detail, oldValue, newValue );
				// 	const oldStateCode = oldValue ? oldValue.split('-')[2]: '';
				// 	const newStateCode = newValue ? newValue.split('-')[2]: '';
				// 	$card.find('.details-link,.details-page-link').each( (index, link) => {
				// 		console.log(link);
				// 		if ( link.getAttribute('href').indexOf('state='+oldStateCode) ){
				// 			link.setAttribute('href', link.getAttribute('href').replace('state='+oldStateCode, 'state='+newStateCode));
				// 		}
				// 	});
				// });
			}

			ctrl.addEventListener('announceProductModeChange', event => {
				/**
				 * maybe register add to cart event
				 */
				$card.attr('data-product-status', event.detail.newValue )
				if ('sellable_done' === event.detail.newValue) {
					pushAnalyticsData( event.detail.productCode, 'add_to_cart' );
				}
			});

		});


	});

} )( jQuery );
